import { useEffect, useState } from "react";
import mammoth from "mammoth";
import { getTermsDocxUrl } from "../utils/termsConfig";
import "../store/register/css/termsDetail.css";
import "./DocxViewer.css";

const DocxViewer = ({ fileName, className = "" }) => {
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!fileName) {
      setHtmlContent("");
      setLoading(false);
      setError("약관 파일을 찾을 수 없습니다.");
      return;
    }

    let isCancelled = false;

    const loadDocx = async () => {
      setLoading(true);
      setError(null);
      setHtmlContent("");

      try {
        const response = await fetch(getTermsDocxUrl(fileName));

        if (!response.ok) {
          throw new Error("약관 파일을 불러오지 못했습니다.");
        }

        const arrayBuffer = await response.arrayBuffer();
        const result = await mammoth.convertToHtml({ arrayBuffer });

        if (!isCancelled) {
          setHtmlContent(result.value);
          setLoading(false);
        }
      } catch (loadError) {
        if (!isCancelled) {
          setError(loadError.message || "약관을 불러오는 중 오류가 발생했습니다.");
          setLoading(false);
        }
      }
    };

    loadDocx();

    return () => {
      isCancelled = true;
    };
  }, [fileName]);

  if (loading) {
    return (
      <div className={`docx-viewer ${className}`.trim()}>
        <p className="docx-viewer-status">약관을 불러오는 중입니다...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`docx-viewer ${className}`.trim()}>
        <p className="docx-viewer-status docx-viewer-error">{error}</p>
      </div>
    );
  }

  return (
    <div className={`docx-viewer terms-detail-content ${className}`.trim()}>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
};

export default DocxViewer;